import purchaseView from './purchase.view'

export default {
  register(eventContext) {
    ;[purchaseView].forEach(callback => {
      callback(eventContext)
    })
  },
}
